import { render } from "./InvoiceItemEditDialog.vue?vue&type=template&id=53191a51&scoped=true"
import script from "./InvoiceItemEditDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceItemEditDialog.vue?vue&type=script&lang=js"

import "./InvoiceItemEditDialog.vue?vue&type=style&index=0&id=53191a51&scoped=true&lang=css"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53191a51"]])

export default __exports__